import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  BARRIER_TYPE_OPTIONS,
  BarrierType,
} from '@/pages/instruments/new-instrument/constants/barrier-types'

export interface BarrierTypeFormFieldProps {}

export const BarrierTypeFormField: React.FC<BarrierTypeFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ barrier_type: BarrierType }>()

  return (
    <FormField
      name="barrier_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Barrier Type</FormLabel>
              <FormError />
            </div>
            <SelectInput
              className={'flex flex-1 min-w-auto! w-full'}
              value={value?.toString()}
              onValueChange={(value) =>
                setValue('barrier_type', value as BarrierType, { shouldValidate: true })
              }
              placeholder={'Select a barrier type'}
              options={BARRIER_TYPE_OPTIONS as unknown as any[]}
            />
          </FormItem>
        )
      }}
    />
  )
}
